module.exports = __webpack_public_path__ + "img/UTANTE-4.ef310dc4.jpg";